import globalStyle from 'constants/global.style';
import styles from './homepage.style';
import TimeNow from 'components/time-now/TimeNow';
import MarqueeComponent from 'components/marquee/Marquee';
import { useEffect, useState } from 'react';
import { PromoDetailResponse, SportMatchHotModel } from 'models/promotionModel';
import commonApi from 'apis/commonApi';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import toast from 'react-hot-toast';
import Modal from 'components/modal/Modal';
import { Game3rdMenuItem } from 'models/commonModel';
import { RootState, useAppDispatch, useAppSelector } from 'cache/store';
import { useNavigate } from 'react-router-dom';
import { LotteryMenu } from 'interfaces/lottery-menu';
import { ltOpenDay } from 'constants/common';
import lotteryApi from 'apis/lotteryApi';
import { toggleFastLotteryHome } from 'features/configSlice';
import TodayLotteryHome from './lottery/TodayLotteryHome';
import HandlerError from 'helper/HandlerError';
import './HomePage.scss';
import alertMsg from 'components/alert-message/alert-message';
import FastTransferGame from 'components/transfer/FastTransferGame';
import classNames from 'classnames';
import VqmmIcon from 'components/vqmm/vqmm-icon';
import luckySpinApi from 'apis/luckySpinApi';
import PromotionHome from './promotion/PromotionHome';
import { appName } from 'config/app.config';
import { css } from '@emotion/css';
import { toggleShowFirstNotice } from 'features/msgSystemSlice';
import bgPopup from 'assets/images/bg/bgpopup.png';
import userApi from 'apis/userApi';
import MatchFootball from './match-football/MatchFootball';

let idHotMatchSport: any;

function HomePage() {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { menuGame, showFirstNotice } = useAppSelector((state: RootState) => state.system);
    const [marqueeTextList, setMarqueeTextList] = useState<PromoDetailResponse[]>([]);
    const [showMsgDetail, setShowMsgDetail] = useState(false);
    const [bannerList, setBannerList] = useState<PromoDetailResponse[]>([]);
    const [msgDetail, setMsgDetail] = useState<{ title: string; content: string; photourl: string }>({} as { title: string; content: string; photourl: string });
    const [loading, setLoading] = useState(false);
    const [lotteryTodayList, setLotteryTodayList] = useState<any[]>([]);
    const [liveCasinoList, setLiveCasinoList] = useState<Game3rdMenuItem[]>([]);
    const { isLogged } = useAppSelector((state: RootState) => state.auth);
    const [gameTransferSelect, setGameTransferSelect] = useState<Game3rdMenuItem | null>(null);

    const [promotionList, setPromotionList] = useState<PromoDetailResponse[]>([]);
    const [hotMatchList, setHotMatchList] = useState<SportMatchHotModel[]>([]);

    useEffect(() => {
        const initMsgSystemBean = async () => {
            try {
                const { data } = await commonApi.getMsgSystemBean({});
                if (!data.msg) {
                    //danh sách thông báo marquee top
                    const marqueeData: PromoDetailResponse[] = data.msglist.filter((item: PromoDetailResponse) => item.status === 1);

                    //danh sách banner top
                    const bannerImg: PromoDetailResponse[] = data.msglist
                        .filter((item: PromoDetailResponse) => item.status === 4 && item.photourl !== '')
                        .sort((a: PromoDetailResponse, b: PromoDetailResponse) => b.param3 - a.param3);
                    // danh sách khuyến mãi
                    const promotionData: PromoDetailResponse[] = data.msglist.filter((item: PromoDetailResponse) => item.status === 0);

                    if (!showFirstNotice) {
                        // popup first login
                        const notiList: PromoDetailResponse[] = data.msglist.filter((item: PromoDetailResponse) => item.status === 2);
                        if (notiList.length > 0) {
                            setTimeout(() => {
                                selectDetailMsg(notiList[0].id);
                            }, 1500);
                        }
                        dispatch(toggleShowFirstNotice(true));
                    }

                    setPromotionList(promotionData);
                    setMarqueeTextList(marqueeData);
                    setBannerList(bannerImg);
                }
            } catch (error) {
                console.log(error);
            }
        };
        initMsgSystemBean();
    }, []);

    useEffect(() => {
        let todayMenu = ltOpenDay[new Date().getDay()];
        let todayLottery = [];
        for (let i = 0; i < LotteryMenu.length; i++) {
            for (let j = 0; j < LotteryMenu[i].submenu.length; j++) {
                if (todayMenu.search(LotteryMenu[i].submenu[j].lotteryID.toString()) > -1) {
                    todayLottery.push(LotteryMenu[i].submenu[j].lotteryID);
                }
            }
        }

        const payload = { lotteryId: todayLottery.join(',').replace(',201', '') };
        const getLotteryOffical4DBean = async () => {
            try {
                const { data } = await lotteryApi.lotteryOffical4DBean(payload);
                const lotteryData = data.listOfficial.map((item: any) => ({
                    listJackpost: getJackpots(item.cursitem.winnumber),
                    lotteryname: item.lotteryname,
                    issue: JSON.parse(item.curissue).issue,
                    opentime: item.cursitem.opentime,
                    endtime: item.cursitem.endtime,
                    servertime: item.servertime,
                    lotteryid: item.lotteryid,
                    hisopentime: item.cursitem.hisopentime,
                }));
                setLotteryTodayList(lotteryData.reverse());
            } catch (error) {
                console.log(error);
            }
        };
        getLotteryOffical4DBean();
        return () => {
            dispatch(toggleFastLotteryHome(false));
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getJackpots = (winnumber: string) => {
        const arrayWinNumber = winnumber.split(',');
        if (arrayWinNumber.length > 0) {
            return arrayWinNumber[0].split('');
        }
        return [];
    };

    const selectDetailMsg = async (id: number) => {
        setLoading(true);
        try {
            const { data } = await commonApi.sysMsgBeanInfo({ id });
            HandlerError(
                data,
                () => {
                    if (!data.msg) {
                        setShowMsgDetail(true);
                        setMsgDetail({
                            title: data.sysmsg.title,
                            content: data.sysmsg.content,
                            photourl: data.sysmsg.photourl || '',
                        });
                    } else {
                        toast.error(data.msg);
                    }
                },
                'sysMessage_view'
            );
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const selectGame = (game: Game3rdMenuItem) => {
        if (!isLogged) {
            alertMsg('Vui lòng đăng nhập');
            return;
        }
        setGameTransferSelect(game);
    };

    useEffect(() => {
        if (menuGame.length > 0) {
            const casinoData = menuGame.find((item: any) => item.gametype === 'LC');
            if (casinoData?.child) {
                setLiveCasinoList(casinoData.child.slice(0, 6));
            }
        }
    }, [menuGame]);

    const checkInTime = (startTime: string) => {
        const timeover = 7200000;
        const now = new Date();
        const timestart = new Date(startTime + ' GMT+7');
        const diffTime = now.getTime() - timestart.getTime();
        if (timeover > diffTime) {
            return true;
        }
        return false;
    };


    //các trận đấu hot
    useEffect(() => {
        const getHotMatch = async () => {
            try {
                const { data } = await userApi.getSportViewData({});
                if (!data.msg) {
                    let sideMatch: SportMatchHotModel[] = data.reslist.filter(
                        (item: SportMatchHotModel) => item.status === 1 && checkInTime(item.startdate)
                    );
                    if (sideMatch.length > 0) {
                        setHotMatchList(sideMatch);
                        idHotMatchSport = setInterval(() => {
                            setHotMatchList((list) => list.filter((item) => checkInTime(item.startdate)));
                        }, 6000);
                    }
                }
            } catch (error) {
                console.log(error);
            }
        };
        getHotMatch();

        return () => {
            idHotMatchSport && clearInterval(idHotMatchSport);
        };
    }, []);

    return (
        <>
            <div className={styles.homeContainer}>
                <div className={styles.bannerSlide}>
                    <Swiper
                        autoplay={{ delay: 5000 }}
                        modules={[Pagination, Autoplay]}
                        pagination={{ clickable: true }}
                        speed={600}
                        loop={bannerList.length > 1} // ✅ kiểm tra trước khi bật loop
                    >
                        {bannerList.map((item) => (
                            <SwiperSlide key={item.id}>
                                <div
                                    className={styles.bannerBg}
                                    // style={{ backgroundImage: `url(${item.photourl})` }}
                                >
                                    <img src={item.photourl} alt="" />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                <div className={styles.marquee}>
                    <div className={globalStyle.container}>
                        <div className="d-flex">
                            <div className={styles.timeNow}>
                                <TimeNow />
                                <img className={styles.megaphone} src={require('assets/images/icons/mega_home.png')} alt="" />
                            </div>
                            <div className={styles.slideText}>
                                <MarqueeComponent dataList={marqueeTextList} onShowDetail={selectDetailMsg} />
                            </div>
                        </div>
                    </div>
                </div>

                {/* lottery  */}
                <section className={`${styles.lottery}`}>
                    <div className={globalStyle.containerLottery}>
                        {/* xo so hom nay */}

                        <TitleSection title="XỔ SỐ HÔM NAY" icon={require('assets/images/icons/ball_lottery_1.png')} hideShowAll />
                        <TodayLotteryHome lotteryList={lotteryTodayList} />
                    </div>
                </section>

                {/* football */}
                <section className={`${styles.football} ${styles.section}`}>
                    <div className={globalStyle.containerLottery}>
                        <div style={{ marginBottom: '24px' }}>
                            <TitleSection title="THỂ THAO" icon={require('assets/images/icons/football.png')} hideShowAll />
                        </div>

                        <div className="sports-content">
                            <div className="home-sports">
                                {hotMatchList.length > 0 ? (
                                    <MatchFootball sportList={hotMatchList} onSelectGame={selectGame} />
                                ) : (
                                    <div className="no-match">
                                        <p>Các trận cầu đỉnh cao đang được cập nhật</p>
                                    </div>
                                )}

                                <div className="home-sports-provider">
                                    <ul>
                                        {['game1', 'game2', 'game3', 'game5', 'game4', 'game6'].map((img, i) => (
                                            <li key={i}>
                                                <img src={require(`assets/images/footer/${img}.png`)} alt="" />
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/* <MatchFootball /> */}
                    </div>
                </section>

                {/* live casino */}
                <section className={`${styles.liveSection} ${styles.section}`}>
                    <div className={globalStyle.container}>
                        <TitleSection title="LIVE CASINO" icon={require('assets/images/icons/live_casino.png')} hideShowAll />
                        <div className={styles.gameWrap}>
                            <div className={styles.gameRight}>
                                {liveCasinoList.map((game) => (
                                    <div className={classNames(`${styles.gameItem} ${styles.itemRight}`, game.golive ? '' : 'comingsoon')} key={game.providercode} onClick={() => selectGame(game)}>
                                        <img className="imgitem" src={require(`assets/images/game-card/LC/${game.iconpc}.png`)} alt="" />
                                        <div className={styles.btnPlayGame}>
                                            <button>
                                                <img src={require(`assets/images/icons/btn-bet.png`)} alt="" />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>

                {/* promotion */}
                <section>
                    <div className={globalStyle.container}>
                        <TitleSection title="KHUYẾN MÃI" icon={require('assets/images/icons/gift.png')} hideShowAll />
                        <PromotionHome promoList={promotionList} />
                    </div>

                    {/* intro page */}
                    <div className="instruction-tin88">
                        <div className="tin88-88">
                            <h3>{appName} - Nhà cái uy tín hàng đầu châu Á</h3>
                            <p>
                                <span className="highlight">{appName}</span> là công ty hoạt động hợp pháp tại Philippines được giám sát bởi tổ chức Gaming Associates và có giấy phép của PAGCOR, chúng
                                tôi tự hào là một trong những nhà cái hàng đầu Châu Á với đầy đủ các sản phẩm trong đó đặc biệt là mạng lưới xổ số tỷ lệ cao bậc nhất thị trường.
                            </p>
                            <p>
                                <span className="highlight">{appName}</span> cung cấp cho bạn trải nghiệm cá cược hoàn toàn mới, chúng tôi mang đến hàng trăm sản phẩm cược như: XỔ SỐ, Thể Thao,
                                Virtual Sport, Game slots, Game bài, Virtual Casino và hệ thống Casino Trực Tuyến tuyệt vời, khách hàng sẽ được tận hưởng một thế giới giải trí trực tuyến hấp dẫn hơn
                                bao giờ hết.
                            </p>
                            <p>
                                <span className="highlight">{appName}</span> với hệ thống nạp rút tiền tự động, nhanh chóng và đa dạng các hình thức thanh toán sẽ giúp quý khách trải nghiệm cá cược
                                tốt nhất.
                            </p>
                            <p>
                                Uy tín và chất lượng là một trong những ưu tiên hàng đầu tại <span className="highlight">{appName}</span>, chúng tôi đảm bảo sự công bằng trong mọi khía cạnh của sản
                                phẩm & dịch vụ. Cho dù đó là gửi tiền, rút tiền, nhà cung cấp trò chơi hoặc thông tin được cung cấp trong tài khoản người chơi của bạn. Mỗi khía cạnh trong{' '}
                                <span className="highlight">{appName}</span> được đảm bảo 100% bởi các nhà cung cấp phần mềm, máy chủ, môi trường casino và các cổng thanh toán. Tiền gửi và rút tiền
                                tại <span className="highlight">{appName}</span> được thực hiện thông qua các công ty đối tác phổ biến và đáng tin cậy nhất cung cấp nhiều lựa chọn khác nhau. Tất cả
                                các nhà cung cấp trò chơi đều sở hữu các tài liệu và giấy chứng nhận cần thiết để đảm bảo một môi trường chơi công bằng với tất cả các trò chơi.
                            </p>
                            <p>
                                Dịch vụ khách hàng tương tác 24/24 và chúng tôi không ngừng nâng cao chất lượng dịch vụ. <span className="highlight">{appName}</span> có bộ phận chăm sóc khách hàng
                                chuyên nghiệp và tận tâm 24 giờ trong ngày và 7 ngày trong tuần, kể cả Chủ Nhật và các ngày Lễ Tết. Nếu bạn có bất kỳ câu hỏi nào về tài khoản của mình, vui lòng cho
                                chúng tôi cơ hội trả lời câu hỏi của bạn. Mục tiêu của chúng tôi là thiết lập một mối quan hệ đáng tin cậy với khách hàng, đem đến cho khách hàng sản phẩm và dịch vụ cá
                                cược tốt nhất. Niềm tin của bạn là thành công của chúng tôi.
                            </p>
                        </div>
                    </div>
                </section>
            </div>

            {/* VQMM  */}
            <VqmmIcon
                onLaunchGame={async () => {
                    if (isLogged) {
                        const { data }: any = await luckySpinApi.initLuckySpin({});

                        if (data?.errorCode === 1) {
                            alertMsg('Đã kết thúc sự kiện');
                        } else {
                            navigate(`/lucky-win`);
                        }
                    } else {
                        alertMsg('Vui lòng đăng nhập');
                    }
                }}
            />

            {/* popup chuyển quỹ nhanh */}
            <Modal isShow={Boolean(gameTransferSelect)} onClose={() => setGameTransferSelect(null)} width="520px">
                {gameTransferSelect ? <FastTransferGame gameData={gameTransferSelect} onClose={() => setGameTransferSelect(null)} /> : <></>}
            </Modal>

            <Modal isShow={showMsgDetail} onClose={() => setShowMsgDetail(false)} closeClickBackdrop height="auto">
                <MsgDetail data={msgDetail} onClose={() => setShowMsgDetail(false)} />
            </Modal>
        </>
    );
}

interface MsgDetailProps {
    data: { title: string; content: string; photourl?: string };
    onClose: () => void;
}

const MsgDetail = (props: MsgDetailProps) => {
    const { data, onClose } = props;
    return (
        <div className={msgDetailStyle.popup}>
            {/* <h6 className="title">{data.title}</h6> */}
            <div className="content">
                {data.photourl !== null && data.photourl !== '' && <img style={{ width: '100%' }} src={data.photourl} alt="" />}
                <div dangerouslySetInnerHTML={{ __html: data.content }}></div>
            </div>
            <div className={msgDetailStyle.wrapClose}>
                <button type="button" onClick={onClose} className="btn-primary">
                    Đóng
                </button>
            </div>
        </div>
    );
};

const msgDetailStyle = {
    popup: css`
        max-width: 600px;
        min-width: 600px;
        margin: 0 auto;
        background: #fff;
        padding: 130px 10px 10px;
        border-radius: 10px;
        background: url(${bgPopup}) center center no-repeat;
        background-size: 100% 100%;
        min-height: 600px;
        max-height: 600px;
        color: #fff;
        .title {
            text-align: center;
            font-size: 22px;
            padding: 5px 0 15px;
        }
        .content {
            max-height: 400px;
            min-height: 400px;
            overflow: auto;
        }
    `,
    wrapClose: css`
        text-align: center;
        margin-top: auto;
        button {
            width: 180px;
            border-radius: 8px;
            padding: 8px 12px;
            background: linear-gradient(to bottom, #6c1aaf, #783abb);
            margin-top: 15px;
        }
    `,
};

interface TitleSectionProps {
    title: string;
    icon: string;
    hideShowAll?: boolean;
    onShowAll?: () => void;
}

const TitleSection = (props: TitleSectionProps) => {
    const { title, icon, hideShowAll, onShowAll } = props;
    const selectShowAll = () => {
        if (onShowAll) onShowAll();
    };

    return (
        <div className={styles.title}>
            <div className="d-flex align-items-center title-game">
                {/* <img src={icon} className={styles.titleIcon} alt="" /> */}
                <h6>{title}</h6>
            </div>
            {!hideShowAll && (
                <button type="button" className={styles.btnViewAll} onClick={selectShowAll}>
                    <span>XEM TẤT CẢ</span>
                    <img src={require('assets/images/icons/arow_left_orange.png')} alt="" />
                </button>
            )}
        </div>
    );
};

export default HomePage;
